

// const manageColumnsConfig =  [
//     {
//         groupId     : 'generic',
//         groupName   : 'Generic',
//         groupType   : 'system',
//         fields      : [
//             'title',
//             'shortId',
//         ]
//     }, {
//         groupId     : 'custom',
//         groupName   : 'Custom',
//         groupType   : 'custom-fields',
//         fields      : [] //customFieldIds
//     }
// ]


import {Group, GroupedData} from "../../../data-structures/group";
import FieldProto from "../../../fields3/proto/field-proto";
import {SEPARATOR} from "../../../gd-components/popover-menu/const";

export default function convertFieldsStructureToConfig(fieldsStructure:GroupedData, restrictedFields?: FieldProto[]):any[] {

    const manageColumnsConfig:any[] = []
    const restrictedFieldsIds = restrictedFields ? _.map(restrictedFields, field=>field.fieldId) : []

    _.map(fieldsStructure, (group:Group)=>{

        const fields : string[] = []

        // restrictedFields if passed show which fields can't be used (and are filtered out)
        let filteredItems = restrictedFields ?
            _.filter(group.items, item=>{
                if (item === SEPARATOR) return true
                return !restrictedFieldsIds.includes(item.fieldId)
            })
            :
            group.items

        let previousIsSeparator: boolean = false // to prevent multiple separators placed consistently
        _.map(filteredItems, (item:FieldProto|typeof SEPARATOR)=>{

            if (!item) {
                console.log("Error #9832 ", item)
                return
            }

            if (item===SEPARATOR) {
                if (!previousIsSeparator) {
                    fields.push(SEPARATOR)
                }
                previousIsSeparator = true
            } else {
                fields.push(item.fieldId)
                previousIsSeparator = false
            }
        })

        manageColumnsConfig.push({
            groupId         : group.value,
            groupName       : group.label,
            groupType       : group.type,
            fields          : fields
        })


    })


    return manageColumnsConfig

}